import api from "../../../../lib/axios";
import type { BasePagingResponse, BaseResponse } from "../../../../lib/api-contract";
import type {
  ResidentReportFilterOption,
  ResidentReportOrganizationOption,
} from "../types/resident-report-filter.types";

type OrganizationOptionResponse = {
  id: string;
  name: string;
  neighborhoods?: Array<{
    id: string;
    name: string;
  }>;
};

export async function getResidentReportOrganizationOptions(
  signal?: AbortSignal,
): Promise<ResidentReportOrganizationOption[]> {
  const response = await api.get<BaseResponse<BasePagingResponse<OrganizationOptionResponse>>>(
    "/v1/auth/organizations",
    { signal },
  );

  return response.data.data?.list.map(({ id, name, neighborhoods }) => ({
    id,
    name,
    neighborhoods: neighborhoods?.map((neighborhood) => ({
      id: neighborhood.id,
      name: neighborhood.name,
    })) ?? [],
  })) ?? [];
}

type UserOptionResponse = {
  label?: string;
  value?: string;
  Label?: string;
  Value?: string;
};

export async function getResidentReportUserOptions({
  search,
  limit = 100,
  signal,
}: {
  search?: string;
  limit?: number;
  signal?: AbortSignal;
}): Promise<ResidentReportFilterOption[]> {
  const response = await api.get<BaseResponse<UserOptionResponse[]>>(
    "/v1/portal/user-options",
    {
      params: {
        limit,
        ...(search ? { search } : {}),
      },
      signal,
    },
  );

  return response.data.data?.flatMap((option) => {
    const id = option.value ?? option.Value ?? "";
    const name = (option.label ?? option.Label ?? "").trim();
    return id && name ? [{ id, name }] : [];
  }) ?? [];
}
